import type { SensorStatus } from "@sitescene/types";

import type { BadgeColors } from "@/components/ui/badges/badge-types";

import { toTitleCase } from "../shared/strings";

export const sensorStatusConfig = (
	status: SensorStatus,
): { color: BadgeColors; label: string } => {
	switch (status) {
		case "active":
			return { color: "success", label: "Online" };
		case "offline":
			return { color: "error", label: "Offline" };
		case "warning":
			return { color: "warning", label: "Warning" };
		default:
			return { color: "gray", label: toTitleCase(String(status)) };
	}
};
